import { queryOptions } from "@tanstack/react-query";
import type { getPartnerListForm } from "../dtos/request/partner.request";
import { getPartnerDetail, getPartnerList, getPartnerQuotation, getPartnerStoreList } from "../v1/partner.service";

export const PARTNER_QUERY_KEY = {
  list: "partner-list",
  detail: "partner-detail",
  quotation: "partner-quotation",
  store: "partner-store",
} as const;

export const usePartnerList = (form: getPartnerListForm) =>
  queryOptions({
    queryKey: [PARTNER_QUERY_KEY.list, form.page, form.size],
    queryFn: () => getPartnerList(form),
    retry: 1,
  });

export const usePartnerStoreList = () =>
  queryOptions({
    queryKey: [PARTNER_QUERY_KEY.store],
    queryFn: getPartnerStoreList,
    retry: 1,
  });

export const usePartnerDetail = (partnerId: string) =>
  queryOptions({
    queryKey: [PARTNER_QUERY_KEY.detail, partnerId],
    queryFn: () => getPartnerDetail(partnerId),
    enabled: !!partnerId,
  });

export const usePartnerQuotation = (partnerId: string) =>
  queryOptions({
    queryKey: [PARTNER_QUERY_KEY.quotation, partnerId],
    queryFn: () => getPartnerQuotation(partnerId),
    enabled: !!partnerId,
    retry: 1,
  });
